export default "__VITE_ASSET__55af268c__"